import React, { useState } from "react";

const Tab = ({ tabs = [], activeTab, onTabChange,showBorder,mt,isNowrap=false,isTransparentBg}) => {
  // Helper function to determine active navigation link style
  const getNavLinkClass = (tab) => {
    return activeTab === tab
      ? "hover:text-[#000000] text-[#333333] border-b-[3px] border-[#6E2D90] font-semibold"
      : "text-[#4c526c] hover:text-[#000000] border-b-2 pb-1 border-transparent ";
  };

  return (
   <div className={`overflow-hidden ${showBorder && "border-b border-solid border-[#eee]"}`} >
      {/* Navbar */}
      <div className={`text-[14px] ${mt ? {mt} : "mt-3"}`}>
        <nav className={`navbar ${!isTransparentBg && "bg-white"} `}>
          <div className="flex items-center  justify-between overflow-x-auto no-scrollbar">
            <div className={`flex space-x-6 ${isNowrap && "whitespace-nowrap"}`}>
              {tabs.map((tab) => (
                <a
                  key={tab.name}
                  href="#"
                  onClick={() => onTabChange(tab.name)}
                  className={getNavLinkClass(tab.name)}
                >
                  {tab.label}
                </a>
              ))}
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Tab;